export default function EscapePhoneNumber(phone: string) {
  return phone.replace(/[^0-9]/g, "")
}
